/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Right_Justify_Center_PosInputs */

const en_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right Justify / Center Position`)
};

const fr_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justification Droite / Position Centree`)
};

const de_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtsbündig / Zentriert`)
};

const it_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allineamento a destra / Posizione centrale`)
};

const ru_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выравнивание по правому краю / Центрирование`)
};

const es_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificar a la derecha / Posición centrada`)
};

const zh_cn2_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右对齐/居中`)
};

const ja_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右揃え / 中央揃え`)
};

const hi_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाईं ओर संरेखित करें / केंद्र में रखें`)
};

const pt_pt2_align_center_right_justify_center_pos = /** @type {(inputs: Align_Center_Right_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificar à direita / Posicionamento centralizado`)
};

/**
* | output |
* | --- |
* | "Right Justify / Center Position" |
*
* @param {Align_Center_Right_Justify_Center_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_right_justify_center_pos = /** @type {((inputs?: Align_Center_Right_Justify_Center_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Right_Justify_Center_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_center_right_justify_center_pos(inputs)
	if (locale === "de") return de_align_center_right_justify_center_pos(inputs)
	if (locale === "it") return it_align_center_right_justify_center_pos(inputs)
	if (locale === "ru") return ru_align_center_right_justify_center_pos(inputs)
	if (locale === "es") return es_align_center_right_justify_center_pos(inputs)
	if (locale === "zh-CN") return zh_cn2_align_center_right_justify_center_pos(inputs)
	if (locale === "ja") return ja_align_center_right_justify_center_pos(inputs)
	if (locale === "hi") return hi_align_center_right_justify_center_pos(inputs)
	if (locale === "pt-PT") return pt_pt2_align_center_right_justify_center_pos(inputs)
	return en_align_center_right_justify_center_pos(inputs)
});